import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';

// import './DeleteModal.css'; // Uncomment if you have this CSS file

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm, chatTitle }) => {
  const { t } = useTranslation();
  
  // Add animation state
  const [modalVisible, setModalVisible] = useState(false);
  
  // Control modal animation
  useEffect(() => {
    if (isOpen) {
      // Small delay to ensure the DOM has updated
      setTimeout(() => setModalVisible(true), 10);
    } else {
      setModalVisible(false);
    }
  }, [isOpen]);
  
  if (!isOpen) return null;
  
  const handleClose = () => {
    setModalVisible(false);
    // Add a delay to match the animation duration before actually closing
    setTimeout(() => onClose(), 300);
  };

  return (
    <>
      {/* Overlay */}
      <div 
        className={`fixed inset-0 bg-black bg-opacity-50 flex items-end sm:items-center justify-center z-50 transition-opacity duration-300 ${
          modalVisible ? 'opacity-100' : 'opacity-0'
        }`}
        onClick={handleClose}
      >
        {/* Modal Container */}
        <div 
          className={`w-full sm:max-w-lg mx-auto overflow-hidden feebBorderPnc shadow-lg transition-transform duration-300 sm:rounded-lg ${
            modalVisible ? 'translate-y-0' : 'translate-y-full sm:translate-y-0 sm:scale-95'
          }`}
          onClick={(e) => e.stopPropagation()}
          style={{
            maxHeight: '90vh',
            width: '100%',
            borderRadius: window.innerWidth < 640 ? '1rem 1rem 0 0' : undefined
          }}
        >
          {/* Header */}
          <div className="flex justify-between items-center px-6 py-4 border-b border-gray-200 feedHeader">
            <h2 className="FeedHeaderPnc">{t('deleteConfirmationMain')} </h2>
            <button 
              onClick={handleClose}
              className="text-black crossFeedBtnPnc"
            >
              <svg className="svgFeedPnc" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>

          {/* Body */}
          <div className="p-6 bg-[#ffffff] contentModalPnc">
            <div className="text-center">
              <h3 className="font-medium subHeadingFeedPnc mb-[24px]">
                {t('deleteConversationConfirmation')}
                {/* Are you sure you want to delete <span className="font-bold">{chatTitle || "this chat"}</span>? */}
              </h3>
              
              {/* Action Buttons */}
              <div className="flex justify-center gap-4">
                <button
                  onClick={handleClose}
                  className="bg-white text-black px-8 py-3 rounded-full font-medium border border-gray-300 hover:bg-gray-50 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300"
                >
                  {t('cancel')}
                </button>
                <button
                  onClick={() => {
                    setModalVisible(false);
                    // Add a delay to match the animation before confirming deletion
                    setTimeout(() => onConfirm(), 300);
                  }}
                  className="bg-[#FF0000] text-white px-8 py-3 rounded-full font-medium hover:bg-red-600 transition-colors focus:outline-none focus:ring-offset-2 focus:ring-red-500 submitFeedPnc deleteBtnPnc"
                >
                  {t('delete')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

// You can create a DeleteModal.css file with the same animation CSS as in FeedbackModal.css
// or use the CSS classes directly in your component

export default DeleteConfirmationModal;